import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useRef, useState } from 'react';
import { useCountryStore } from '@jove-frontend/uikit';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function NewCountrySelect(_ref) {
  var _selectedCountry$flag, _selectedCountry$flag2;

  var className = _ref.className,
      name = _ref.name,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Country of your business' : _ref$label,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 'GB' : _ref$value,
      onChange = _ref.onChange,
      allowedCountries = _ref.allowedCountries;

  var _useState = useState(''),
      searchTerm = _useState[0],
      setSearchTerm = _useState[1];

  var _useState2 = useState(false),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(null),
      selectedCountry = _useState3[0],
      setSelectedCountry = _useState3[1];

  var _useState4 = useState([]),
      allCountries = _useState4[0],
      setAllCountries = _useState4[1];

  var searchInputRef = useRef(null);

  var _useCountryStore = useCountryStore(function (_ref2) {
    var state = _ref2.state,
        actions = _ref2.actions;
    return [state, actions];
  }),
      _useCountryStore2 = _slicedToArray(_useCountryStore, 2),
      countries = _useCountryStore2[0].countries,
      initialize = _useCountryStore2[1].initialize;

  useEffect(function () {
    initialize();

    var closeOnEscape = function closeOnEscape(e) {
      if (e.key === 'Escape') {
        setIsOpen(false);
      }
    };

    var closeOnClickOutside = function closeOnClickOutside(e) {
      if (e.target instanceof HTMLElement && !e.target.closest('.jv-country-select')) {
        setIsOpen(false);
      }
    };

    document.addEventListener('keydown', closeOnEscape);
    document.addEventListener('click', closeOnClickOutside);
    return function () {
      document.removeEventListener('keydown', closeOnEscape);
      document.removeEventListener('click', closeOnClickOutside);
    };
  }, []);
  useEffect(function () {
    if (isOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isOpen]);
  useEffect(function () {
    if (value && countries !== null && countries !== void 0 && countries.length) {
      var country = countries.find(function (country) {
        return country.code === value;
      });
      setSelectedCountry(country);
    }

    setAllCountries(countries);
  }, [countries, value]);

  var handleCountrySelect = function handleCountrySelect(country) {
    setSelectedCountry(country);
    if (onChange) onChange(country.code);
    setIsOpen(false);
  };

  var filteredCountries = allCountries !== null && allCountries !== void 0 && allCountries.length ? allCountries.filter(function (country) {
    return country.name.toLowerCase().startsWith(searchTerm.toLowerCase());
  }) : [];

  if ((allowedCountries === null || allowedCountries === void 0 ? void 0 : allowedCountries.length) > 0) {
    filteredCountries = filteredCountries.filter(function (item) {
      return allowedCountries.includes(item.code);
    });
  }

  if (!filteredCountries) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx('jv-country-select relative my-4 flex w-full', className),
    children: [/*#__PURE__*/_jsxs("button", {
      onClick: function onClick() {
        return setIsOpen(!isOpen);
      },
      onFocus: function onFocus() {
        return setIsOpen(true);
      },
      className: "grid w-full grid-cols-[25px,1fr,25px] items-center gap-5 space-x-2 rounded-md border border-gray-300 px-4 py-2",
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex items-center",
        children: selectedCountry !== null && selectedCountry !== void 0 && (_selectedCountry$flag = selectedCountry.flags) !== null && _selectedCountry$flag !== void 0 && _selectedCountry$flag.svg ? /*#__PURE__*/_jsx(SvgRenderer, {
          svgString: selectedCountry === null || selectedCountry === void 0 ? void 0 : (_selectedCountry$flag2 = selectedCountry.flags) === null || _selectedCountry$flag2 === void 0 ? void 0 : _selectedCountry$flag2.svg,
          className: "text-blue-500",
          width: "25px",
          height: "auto"
        }) : /*#__PURE__*/_jsx("div", {
          className: "h-[16px] w-[25px]"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col text-left",
        children: [/*#__PURE__*/_jsx("label", {
          htmlFor: name,
          className: "text-sm text-slate-600",
          children: label
        }), /*#__PURE__*/_jsx("span", {
          children: selectedCountry ? selectedCountry.name : 'Select a Country'
        })]
      }), /*#__PURE__*/_jsx(ExpandMoreRoundedIcon, {
        className: "text-right text-slate-600"
      })]
    }), isOpen && /*#__PURE__*/_jsxs("div", {
      className: "absolute z-10 w-full rounded-md border border-gray-300 bg-white shadow-lg",
      children: [/*#__PURE__*/_jsx("div", {
        className: "p-2",
        children: /*#__PURE__*/_jsx("input", {
          ref: searchInputRef,
          type: "text",
          value: searchTerm,
          onChange: function onChange(e) {
            return setSearchTerm(e.target.value);
          },
          placeholder: "Search for a country",
          className: "w-full rounded-md border border-gray-300 p-2 focus:outline-none focus:ring focus:ring-blue-300"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "max-h-60 overflow-y-auto",
        children: filteredCountries.length > 0 ? filteredCountries.map(function (country) {
          var _country$flags;

          return /*#__PURE__*/_jsxs("div", {
            onClick: function onClick() {
              return handleCountrySelect(country);
            },
            className: "flex cursor-pointer items-center gap-4 px-4 py-2 hover:bg-gray-100",
            children: [/*#__PURE__*/_jsx(SvgRenderer, {
              svgString: country === null || country === void 0 ? void 0 : (_country$flags = country.flags) === null || _country$flags === void 0 ? void 0 : _country$flags.svg,
              className: "text-blue-500",
              width: "25px",
              height: "auto"
            }), country.name]
          }, country.name);
        }) : /*#__PURE__*/_jsx("div", {
          className: "p-4 text-center text-gray-500",
          children: "No countries found"
        })
      })]
    })]
  });
}

var SvgRenderer = function SvgRenderer(_ref3) {
  var svgString = _ref3.svgString,
      className = _ref3.className,
      _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? '100%' : _ref3$width,
      _ref3$height = _ref3.height,
      height = _ref3$height === void 0 ? '100%' : _ref3$height;
  return /*#__PURE__*/_jsx("div", {
    className: "inline-block ".concat(className || ''),
    style: {
      width: width,
      height: height
    },
    dangerouslySetInnerHTML: {
      __html: svgString
    }
  });
};